export default __webpack_public_path__ + "static/media/bg-all-products.dda4b74c.png";